<template>
<div>
 <v-snackbar v-model="snackbar" top :timeout="2000">
        {{ snackbar_msg }}
        <template v-slot:action="{ attrs }">
            <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
                Close
            </v-btn>
        </template>
    </v-snackbar>
    <v-btn @click="open()" depressed color="teal" dark> Edit</v-btn>
        <v-dialog v-model="window" scrollable fullscreen>
           
            <v-card v-if="item" rounded="0">
                <v-card-title style="background-color:#0154a2;color:#ffffff" class="pa-1">
              
                    {{item.fullname}}
                    
                    <v-spacer></v-spacer>
                          <v-btn color="white" text @click="closeWindow" dark>
                       ปิด
                    </v-btn>
                    </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px;">

                    <div class="row">
                        <div class="col-sm-6">
                            <v-card class="mx-auto mt-6" max-width="500" outlined>
                                <v-list-item three-line>
                                    <v-list-item-content>
                                        <v-list-item-title class="text-h5 mb-1">
                                            {{item.title}}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            <div><b>CODE :</b> {{item.code}}</div>
                                        </v-list-item-subtitle>

                                        <v-list-item-subtitle>
                                            <div v-if="item.for_sale=='A'"><b>ขาย :</b> {{item.price}}</div>
                                            <div v-if="item.for_rent=='A'"><b>ให้เช่า :</b> {{item.price_rent}}</div>
                                        </v-list-item-subtitle>

                                    </v-list-item-content>

                                    <v-list-item-avatar tile size="80" color="grey"><img :src="item.picture"></v-list-item-avatar>
                                </v-list-item>

                            </v-card>

                            <v-card class="mx-auto mt-6 pa-5" max-width="500" outlined>

                                <div class="row mb-3">
                                    <div class="col-sm-3"><b>ชื่อ - นามสกุล</b></div>
                                    <div class="col-sm-9"> {{item.fullname}}</div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-sm-3"><b>อีเมล์</b></div>
                                    <div class="col-sm-9">{{item.email}}</div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-sm-3"><b>เบอร์โทร</b></div>
                                    <div class="col-sm-9">{{item.phone }}</div>
                                </div>
 

                                <div class="row mb-3">
                                    <div class="col-sm-3"><b>ข้อความ</b></div>
                                    <div class="col-sm-9" v-html="item.detail"></div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-sm-3"><b>วันที่</b></div>
                                    <div class="col-sm-9">{{item.created}}</div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-sm-3"><b>อัปเดท</b></div>
                                    <div class="col-sm-9">{{item.updated}}</div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-sm-3"><b>สถานะ</b></div>
                                    <div class="col-sm-9">{{item.status_title}}</div>
                                </div>

                            </v-card>
                        </div>
                        <div class="col-sm-6">

                              <div class="row mt-4">

        <div class="col-sm-12" v-if="data">
            <v-autocomplete outlined v-if="status" v-model="data.c_status" :items="status" item-text="text" item-value="value" label="สถานะ"></v-autocomplete>

        </div>

        <div class="col-sm-12">
            <v-textarea v-model="data.msg" outlined name="input-7-4" label="รายละเอียดความคืบหน้า"></v-textarea>
        </div>

        <div class="text-center col-sm-12">
            <v-btn depressed color="primary" @click="updateStatus()">
                บันทึก
            </v-btn>
        </div>

       
    </div>


                        </div>
                    </div>

                </v-card-text>
         
           
            </v-card>
        </v-dialog>
    

</div>
</template>

<script>
import ContactStatus from '@/views/Contact/ContactStatus'
export default {

    components: {
        ContactStatus
    },
    props: {
         
        contact_id: null,
    },

    data: () => ({
        window: null,
        item: null,
        data:null,
           snackbar: null,
        snackbar_msg: null,
        status:null,

    }),

    computed: {

    },

    watch: {
     
    },

    methods: {

           open() {

            this.getItem()
            this.getStatusList()
         

            this.window = true

        },


         updateItem() {

             this.getItem();
          
            this.$emit('updateItem', true)
        },

        closeWindow() {
            this.window = false
            this.$emit('closeWindows', true)
        },


         updateStatus() {
            let $vm = this;

            this.snackbar_msg = null
            this.snackbar = null

            const formData = new FormData();
            formData.append("c_status", $vm.data.c_status);
            formData.append("msg", $vm.data.msg);
            formData.append("contact_id", $vm.contact_id);

            var url = "contact/setStatus?time=" + Math.random();
            // console.log(url);
            this.$http
                .post(url, this.formData(formData))
                .then(function (res) {
                    console.log(res.data);

                    if (res.data.set_status == 'success') {
                        $vm.$emit('updateItem', true)
                    }

                    $vm.snackbar_msg = 'อัปเดทสถานะเรียบร้อยแล้วค่ะ'
                    $vm.snackbar = true
 

                })
                .catch(function (error) {
                    console.log(error);
                });
        },



        getItem() {
            let url = "contact/one?contact_id=" + this.contact_id;
            console.log(url)

            this.loading = true

            let $vm = this;
            this.$http
                .post(url, this.formData())
                .then(function (res) {
                    console.log(res.data);

                    $vm.loading = false
                    $vm.item = res.data.item
                     $vm.data = res.data.item
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
           getStatusList() {
            let url = "contact/status";
            console.log(url)

            this.loading = true

            let $vm = this;
            this.$http
                .post(url, this.formData())
                .then(function (res) {
                    console.log(res.data);

                    $vm.status = Object.values(res.data.status)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },

    },
    created() {

    },

};
</script>
